// Update BIS button
(() => {
  const section = document.querySelector('#MainContent > .shopify-section .product-information');

  if (!section) {
    return;
  }

  const targetNode = section.querySelector('.buy-buttons-block');

  if (!targetNode) {
    console.error('Observer target not found.');
    return;
  }

  const findAndModifyButton = (/** @type {Element} */ container) => {
    const buttons = container.querySelectorAll('button');

    for (const button of buttons) {
      if (button.textContent.trim() === 'Notify me when back in stock') {
        button.classList.add('button', 'button--klaviyo-BIS');
        console.log('"Notify Me" button found and class added.');
      }
    }
  };

  const callback = (/** @type {Array<MutationRecord>} */ mutationsList, /** @type {MutationObserver} */ observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        findAndModifyButton(targetNode);
      }
    }
  };

  const observer = new MutationObserver(callback);
  const config = { childList: true, subtree: true };

  observer.observe(targetNode, config);
})();

// Update Stamped elements
(() => {
  const section = document.querySelector('#stamped-main-widget');

  if (!section) {
    return;
  }

  let observer;

  const findAndModifyElements = (/** @type {Element} */ container) => {
    const write_review_button = container.querySelector('.stamped-summary-actions-newreview');
    if (write_review_button) {
      write_review_button.classList.remove('stamped-summary-actions-newreview');
      write_review_button.classList.add('button');
    }

    const submit_review_button = container.querySelector('#stamped-button-submit');
    if (submit_review_button) {
      submit_review_button.classList.remove('stamped-button', 'stamped-button-primary', 'button-primary', 'btn', 'btn-primary');
      submit_review_button.classList.add('button');
    }

    container.querySelectorAll('.stamped-form-input:not(:has(textarea)), .stamped-form-input-text, .stamped-form-input-email, .stamped-form-input-textarea').forEach((input) => {
      if (input.classList.contains('stamped-starrating')) {
        return;
      }
      input.classList.remove('stamped-form-input', 'stamped-form-input-text', 'stamped-form-input-email', 'stamped-form-input-textarea');
      input.classList.add('contact-form__input');
    });
  };

  const callback = (/** @type {Array<MutationRecord>} */ mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        findAndModifyElements(section);
      }
    }
  };

  observer = new MutationObserver(callback);

  findAndModifyElements(section);

  const config = { childList: true, subtree: true };
  observer.observe(section, config);
})();